import { useCallback } from "react";
import { DialogStateReturn, useDialogState as useReakitDialogState } from "reakit/Dialog";

interface UseDialogStateOptions {
  beforeShow?: () => unknown | Promise<unknown>;
  afterShow?: () => unknown | Promise<unknown>;
  beforeHide?: () => unknown | Promise<unknown>;
  afterHide?: () => unknown | Promise<unknown>;
}

export const useDialogState = (options?: UseDialogStateOptions): DialogStateReturn => {
  const state = useReakitDialogState({ animated: true });

  const show = useCallback(async () => {
    await options?.beforeShow?.();
    state.show();
    await options?.afterShow?.();
  }, [state, options]);

  const hide = useCallback(async () => {
    await options?.beforeHide?.();
    state.hide();
    await options?.afterHide?.();
  }, [state, options]);

  const toggle = useCallback(async () => {
    if (state.visible) {
      await hide();
    } else {
      await show();
    }
  }, [state, show, hide]);

  const setVisible = useCallback(
    async (visible: boolean) => {
      if (visible) {
        await show();
      } else {
        await hide();
      }
    },
    [show, hide],
  );

  return {
    ...state,
    show,
    hide,
    setVisible,
    toggle,
  };
};
